import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getProfile } from "../../api/profileService";
import { getFromStorage } from "../../lib/storage";

const ConsentBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const checkConsent = async () => {
      const token = getFromStorage("lmsCCToken");
      if (!token) {
        setShowBanner(false);
        return;
      }

      try {
        const res = await getProfile();
        const data = res?.responsePacket || {};

        // Show banner if user is logged in but consent is not active
        if (!data.consentActive) {
          setShowBanner(true);
        } else {
          setShowBanner(false);
        }
      } catch (error) {
        console.error("Error checking consent:", error);
        setShowBanner(false);
      }
    };

    checkConsent();

    // Listen for profile updates
    const handleProfileUpdate = () => {
      checkConsent();
    };
    window.addEventListener("profileUpdated", handleProfileUpdate);

    // Listen for logout event
    const handleLogout = () => {
      setShowBanner(false);
    };
    window.addEventListener("userLoggedOut", handleLogout);

    return () => {
      window.removeEventListener("profileUpdated", handleProfileUpdate);
      window.removeEventListener("userLoggedOut", handleLogout);
    };
  }, []);

  if (!showBanner || dismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-amber-50 border-t border-amber-200 px-4 py-3 z-40 shadow-lg">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm text-amber-800">
          <span className="text-lg">📋</span>
          <span>
            Please accept our{" "}
            <Link to="/TermsConditionsPage" className="text-blue-600 hover:underline">
              Terms
            </Link>
            ,{" "}
            <Link to="/PrivacyPolicyPage" className="text-blue-600 hover:underline">
              Privacy Policy
            </Link>
            {" & "}
            <Link to="/RefundPolicyPage" className="text-blue-600 hover:underline">
              Refund Policy
            </Link>
            {" "}to make purchases.
          </span>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to="/MyProfilePage"
            className="px-4 py-1.5 bg-gray-900 text-white text-sm rounded hover:bg-gray-800 transition"
          >
            Go to Profile
          </Link>
          <button
            onClick={() => setDismissed(true)}
            className="text-gray-500 hover:text-gray-700 text-lg"
            title="Dismiss"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;

